export const SCORING_WEIGHTS = {
  risk: {
    gapSevereDeduction: 25,
    gapWarningDeduction: 12,
    concentrationDeduction: 20,
    sectorConcentrationDeduction: 12,
  },
  diversification: {
    tooFewHoldings: 15,
    tooManyHoldings: 5,
    top10Concentrated: 12,
    top3Concentrated: 10,
    unbalancedAssetClasses: 8,
  },
  protection: {
    criticalRiskDeduction: 18,
    highRiskDeduction: 10,
    crisisSevereLossDeduction: 20,
    crisisModerateLossDeduction: 12,
    crisisMinorLossDeduction: 5,
    crisisBeatSpBonus: 8,
  },
  performance: {
    efficiencyWeight: 0.8,
    optimizationWeight: 0.2,
    optimizationBonusHigh: 90,
    optimizationBonusMed: 70,
    optimizationBonusLow: 50,
    optimizationBonusNone: 30,
  },
  tax: {
    baseScore: 80,
    harvestableBonus: 10,
    inefficientDeduction: 30,
  },
  planning: {
    criticalMissingDeduction: 15,
  },
  lifetimeIncome: {
    coreSecuredBonus: 15,
    partiallyCoveredBonus: 5,
    maxDrawdownDeduction: 20,
  }
};
